import React from 'react';
import QMenu from 'components/QMenu';
import AlarmOn from '@mui/icons-material/AlarmOn';
import AlarmOff from '@mui/icons-material/AlarmOff';

import { schedTxViewsWindows, schedTxViewsMac } from 'data/accountBalances/types';

interface ScheduleViewMenuProps {
  reminderSetting?: string | number;
  onChange?: (value: string | number) => void;
  isWindows?: boolean;
}

const ScheduleViewMenu: React.FC<ScheduleViewMenuProps> = ({
  reminderSetting,
  onChange,
  isWindows,
  ..._other
}) => (
  <QMenu
    menuIcon={!reminderSetting || reminderSetting === 'off' || reminderSetting === '0' ? AlarmOff : AlarmOn}
    name="schedTxnMenu"
    title="Show reminders in register"
    // @ts-expect-error: mediumNoPadding is a custom size not in QMenu types
    menuIconButtonSize="mediumNoPadding"
    options={[
      {
        label: 'Show reminders for',
        groupId: 'reminders',
        isGroupList: true,
        selected: String(reminderSetting ?? 0),
        groupList: isWindows ? schedTxViewsWindows : schedTxViewsMac,
      },
    ]}
    // @ts-expect-error: onChange signature mismatch with QMenu expected type
    onChange={onChange}
  />
);

export default ScheduleViewMenu;



